<template>
  <div class="form-group">
    <div class="d-flex justify-content-between align-items-center">
      <LabelText :label-for="name">
        {{ label }}
      </LabelText>
      <slot name="labelSuffix" />
    </div>
    <div
      class="px-0"
      :class="`col-${col} d-flex align-items-center`">
      <slot name="fieldPrepend" />
      <b-form-input
        :id="name"
        :value="_value"
        :name="name"
        :placeholder="placeholder"
        :type="type"
        :disabled="disabled"
        :autocomplete="autocomplete"
        v-on="customListeners" />
    </div>
    <BaseErrorMessage
      :color="errorTextColor"
      :errors="errors" />
  </div>
</template>

<script>
import LabelText from '@/components/parts/LabelText.vue'
import BaseErrorMessage from '@/components/parts/BaseErrorMessage.vue'
export default {
  name: 'BaseTextFieldGroup',
  components: {
    LabelText,
    BaseErrorMessage
  },
  props: {
    value: {
      type: [String, Number],
      default: null
    },
    label: {
      type: String,
      required: true
    },
    errors: {
      type: Array,
      default: () => []
    },
    errorTextColor: {
      type: String,
      default: 'primary'
    },
    col: {
      type: [String, Number],
      default: 12
    },
    type: {
      type: String,
      default: 'text' 
    },
    name: {
      type: String,
      default: undefined
    },
    placeholder: {
      type: String,
      default: undefined
    },
    emptyStrToNull: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    autocomplete: {
      type: String,
      default: 'off'
    }
  },
  computed: {
    _value: {
      get() {
        return this.value
      },
      set(v) {
        return this.$emit('input', v)
      }
    },
    customListeners() {
      return {
        ...this.$listeners,
        input: this.onInput,
      }
    }
  },
  methods: {
    onInput(input) {
      if (input !== '') {
        this.$emit('input', input)
        return
      }

      this.$emit('input', this.emptyStrToNull ? null : input)
    }
  }
}
</script>

<style>

</style>